import script from "./LanguageSwitcher.vue?vue&type=script&lang=ts&setup=true"
export * from "./LanguageSwitcher.vue?vue&type=script&lang=ts&setup=true"

import "./LanguageSwitcher.vue?vue&type=style&index=0&id=77e60ff5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77e60ff5"]])

export default __exports__